import { TopologyCountry } from '@@types'
import { gql, useQuery } from '@apollo/client'

type Query = {
  topology: {
    countries: TopologyCountry[]
  }
}


export const GQL_QUERY_TOPOLOGY = gql`
  query getTopology {
    topology {
      countries {
        id
        name
        ISO2
        ISO3
        web_domain
        iso_numeric
        phone_code
        currency_name
        currency_symbol
        language_codes
        regions {
          id
          name
          cities {
            id
            name
            defaultGeoPoint {
              latitude
              longitude
            }
            defaultShop {
              id
              slug
              name
              customerName

              address
              shopGeoPoint {
                latitude
                longitude
              }
              status

              min_price
              minOrderCost

              phone

              open_time
              close_time


              isPickupDeliveryAvailable
              shopPickupDeliveryCost

            }
          }
        }
      }
    }
  }
`

export const useFetchTopology = () => {
  const { data, loading, error } = useQuery<Query>(GQL_QUERY_TOPOLOGY)

  const countries = data?.topology.countries || []
  
  const getRegions = (countryId?: string) => {
    if (!countryId) return data?.topology?.countries?.flatMap(c => c.regions) || []

    const country = countries.find(c => c.id === countryId)
    return country?.regions || []
  }

  const getCities = (regionId?: string) => {
    if (!regionId) return getRegions()?.flatMap(r => r.cities) || []

    const region = getRegions().find(r => r.id === regionId)
    return region?.cities || []
  }

  const getShops = (cityId?: string) => {
    if (!cityId) return getCities()?.flatMap(c => c.shops) || []

    const city = getCities().find(c => c.id === cityId)
    return city?.shops || []
  }

  const getDefaultShop = (cityId: string) => {
    const city = getCities().find(c => c.id === cityId)
    return city?.defaultShop
  }

  return { 
    data, 
    loading, 
    error,
    getRegions,
    getCities,
    getShops,
    getDefaultShop
  }
}
